var render, staticRenderFns
import script from "./CategoryArticleField.vue?vue&type=script&lang=js&"
export * from "./CategoryArticleField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ac3112')) {
      api.createRecord('66ac3112', component.options)
    } else {
      api.reload('66ac3112', component.options)
    }
    
  }
}
component.options.__file = "resources/js/pages/orders/fields/CategoryArticleField.vue"
export default component.exports